/** Legacy strings for التلعيب — Locale/Resources.ar.resx and Locale/General.ar.resx. */

const shared = {
  setPeriod: 'تحديد فترة', // Resources.Set_Period
  /* The two halves of the legacy daterangepicker that `تحديد فترة` opens — the
     same pair the dashboard filter already uses. */
  from: 'من', // Resources.Date_From
  to: 'إلي', // Resources.Date_To
  getReport: 'عرض التقرير', // General.getReport
  active: 'نشط', // Resources.IsActive
  inactive: 'غير مفعلة', // Resources.InActive
  edit: 'تعديل', // Resources.Edit
  delete: 'حذف', // Resources.Delete
  addNew: 'إضافة جديدة', // Resources.addNew
  close: 'إغلاق',
}

export const transactionsStrings = {
  ...shared,
  title: 'سجل العمليات', // Resources.PointsTransactions
  subtitle: 'كل نقطة مُنحت أو خُصمت، ومتى ولماذا',
  empty: 'لا توجد عمليات في هذه الفترة',
  actionFailed: 'تعذر تحميل السجل',

  /** The two sides of `IsPositive`, for the type column and its export. */
  positive: 'إيجابية',
  negative: 'سلبية',

  columns: {
    activity: 'نوع النشاط', // Resources.EventType
    user: 'اسم المستخدم', // Resources.Username
    timestamp: 'التاريخ', // Resources.Timestamp
    points: 'النقاط', // Resources.Points
    percentage: 'النسبة في حالة التكرار', // Resources.PercentageOnDuplication
    type: 'نوع النقاط', // Resources.PointsType
    opposite: 'تأثير عكسي؟', // Resources.EffectOpposite
    resetDate: 'تاريخ المسح', // Resources.ResetDate
  },
}

export const resetLogsStrings = {
  ...shared,
  title: 'تصفير النقاط', // Resources.PointsResetLogs
  subtitle: 'كل مرة صُفّرت فيها نقاط المشاركين وبدأت فترة جديدة',
  empty: 'لم يجرِ تصفير النقاط بعد',
  actionFailed: 'تعذر تحميل عمليات التصفير',

  columns: {
    timestamp: 'التاريخ', // Resources.Timestamp
    user: 'اسم المستخدم', // Resources.Username
    notes: 'ملاحظات', // Resources.Notes
  },

  /** The link column opens the transactions that this reset cleared. */
  viewTransactions: 'سجل العمليات', // Resources.PointsTransactions

  /* Not legacy wording — the legacy button is a bare `إضافة جديدة` for an action
     that zeroes every participant's points and cannot be undone. */
  create: 'تصفير نقاط الجميع',
  createTitle: 'تصفير نقاط الجميع؟',
  createConfirm: 'سيُصفَّر رصيد كل مشارك وتبدأ فترة جديدة. العمليات السابقة تبقى في السجل، ولا يمكن التراجع عن هذا الإجراء.',
  created: 'تم تصفير النقاط وبدأت فترة جديدة',
  notesHint: 'سبب التصفير — وهو الشيء الوحيد الذي يُحفظ عن هذه العملية',
}

export const analysisStrings = {
  ...shared,
  title: 'النتائج', // Resources.PointsAnalysis
  subtitle: 'وضع المنشأة، وتوزّع المشاركين على مستويات الخطر',
  empty: 'لا يوجد مشاركون مطابقون',
  actionFailed: 'تعذر تحميل النتائج',

  /* The list filter is one or the other and cannot be both — the query binds a
     non-nullable bool, so "no choice" is silently a choice. It is asked for. */
  pointsType: 'ترتيب حسب',
  positive: 'النقاط الإيجابية',
  negative: 'النقاط السلبية',

  allTime: 'منذ البداية',
  period: 'الفترة',
  spread: 'توزّع المشاركين',
  organizationRisk: 'مستوى خطر المنشأة',
  bandUsers: 'مشارك',

  columns: {
    userName: 'اسم المستخدم', // Resources.Username
    name: 'الإسم', // Resources.Name
    department: 'الإدارة', // Resources.Department
    positive: 'مجموع النقاط الإيجابية', // Resources.PositiveTotalPoints
    negative: 'مجموع النقاط السلبية', // Resources.NegativeTotalPoints
    riskLevel: 'مستوى الخطر', // Resources.RiskLevel
    badges: 'الأوسمة', // Resources.Badges
  },

  /** Not legacy — the legacy page carries no summary, which is what left a
      screen called "النتائج" showing a list and no result. */
  summary: {
    caption: 'ملخص النتائج',
    people: 'المشاركون',
    positive: 'إجمالي النقاط الإيجابية',
    negative: 'إجمالي النقاط السلبية',
    average: 'متوسط النقاط للمشارك',
  },
}

export const gamificationSettingsStrings = {
  ...shared,
  title: 'الإعدادات', // Resources.Settings
  subtitle: 'التلعيب', // Resources.Gamification


  actionFailed: 'تعذر إتمام العملية',
  saved: 'تم الحفظ بنجاح',
  save: 'حفظ',
  required: 'الحقل مطلوب',
  nameAr: 'الاسم بالعربية',
  nameEn: 'الاسم بالإنجليزية',
  descriptionAr: 'الوصف بالعربية',
  descriptionEn: 'الوصف بالإنجليزية',

  /** The settings block — the legacy keeps it above the activities table. */
  settings: {
    tab: 'إعدادات التلعيب',
    enabled: 'تفعيل التلعيب',
    enabledHint: 'عند الإيقاف لا تُحتسب أي نقاط ولا تُمنح شارات',
    notifications: 'إشعارات التلعيب',
    notificationsHint: 'إشعار المستخدم عند كسب النقاط أو الحصول على شارة',
    leaderBoard: 'لوحة المتصدرين',
    showLeaderBoard: 'إظهار لوحة المتصدرين للمستخدمين',
    topUsersOnlyWithBadges: 'إظهار الحاصلين على شارات فقط',
    leaderBoardNameAr: 'اسم اللوحة بالعربية',
    leaderBoardNameEn: 'اسم اللوحة بالإنجليزية',
    leaderBoardUsersCount: 'عدد المستخدمين المعروضين',
  },

  activityForm: {
    add: 'نشاط جديد',
    edit: 'تعديل النشاط',
    eventType: 'نوع النشاط',
    points: 'النقاط',
    isPositive: 'نقاط إيجابية',
    isPositiveHint: 'عند الإيقاف تُخصم النقاط بدل أن تُمنح',
    effectOpposite: 'يلغي أثر النشاط المعاكس',
    percentage: 'النسبة عند التكرار (%)',
    percentageHint: 'اتركه فارغاً إذا كان التكرار يمنح النقاط كاملة',
    enabled: 'هذا النشاط مفعل',
    empty: 'لا توجد أنشطة بعد',
    examNote: 'نشاط «اجتياز الاختبارات» يمنح النقاط بحسب درجة الاختبار، لا بعدد ثابت.',
  },

  badgeForm: {
    add: 'شارة جديدة',
    edit: 'تعديل الشارة',
    points: 'النقاط المطلوبة',
    image: 'صورة الشارة',
    imageHint: 'صورة PNG مربعة',
    enabled: 'هذه الشارة مفعلة',
    empty: 'لا توجد شارات بعد',
    awarding: 'طريقة عرض الشارات',
    awardingHint: 'ما يظهر في ملف المستخدم',
    awardingAll: 'كل الشارات المكتسبة',
    awardingLast: 'آخر شارة فقط',
  },

  riskForm: {
    add: 'مستوى جديد',
    edit: 'تعديل المستوى',
    min: 'الحد الأدنى',
    max: 'الحد الأعلى',
    maxHint: 'اتركه فارغاً لمستوى مفتوح بلا حد أعلى',
    openEnded: 'بلا حد',
    enabled: 'هذا المستوى مفعل',
    empty: 'لا توجد مستويات بعد',
  },

  /** No delete endpoint exists for any of the three — see COSMETIC_UI.md. */
  noDelete: 'لا يمكن حذف العناصر من هنا — لم تُنقل هذه العملية إلى الواجهة البرمجية. يمكن إيقاف العنصر بدلاً من حذفه.',

  tabs: {
    settings: 'إعدادات التلعيب',
    activities: 'الأنشطة', // Resources.PointsActivities
    badges: 'الشارات', // Resources.PointsBadges
    riskLevels: 'مستويات الخطر', // Resources.PointRiskLevels
  },

  activities: {
    name: 'نوع النشاط', // Resources.EventType
    points: 'النقاط', // Resources.Points
    percentage: 'النسبة في حالة التكرار', // Resources.PercentageOnDuplication
    type: 'نوع النقاط', // Resources.PointsType
    opposite: 'تأثير عكسي؟', // Resources.EffectOpposite
    status: 'نشط', // Resources.IsActive
  },

  badges: {
    name: 'الإسم', // Resources.Name
    points: 'النقاط الإيجابية', // Resources.PositivePoints
    description: 'الوصف', // Resources.Description
    status: 'نشط', // Resources.IsActive
  },

  riskLevels: {
    name: 'الإسم', // Resources.Name
    min: 'الحد الأدنى (النقاط السلبية)', // Resources.MinLevel (Resources.NegativePoints)
    max: 'الحد الأعلى (النقاط السلبية)', // Resources.MaxLevel (Resources.NegativePoints)
    status: 'نشط', // Resources.IsActive
  },

  deleteConfirm: 'هل تريد حذف هذا المدخل؟',

  deleted: 'تمت العملية بنجاح', // Operation_Completed_Successfully
}
